import { Box } from '@mui/material';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BIIntroducePage from '../components/pages/BIIntroducePage/BIIntroducePage';
import CenterPage from '../components/pages/CenterPage/CenterPage';
import HistoryPage from '../components/pages/HistoryPage/HistoryPage';
import MessagePage from '../components/pages/MessagePage/MessagePage';
import VisitWayPage from '../components/pages/VisitWayPage/VisitWayPage';

const BoBIs = () => {
  return <Box>BoBIs</Box>;
};
const Message = () => {
  return <MessagePage />;
};
const History = () => {
  return <HistoryPage />;
};
const BoBCenterIntroduce = () => {
  return <CenterPage />;
};
const BIIntroduce = () => {
  return <BIIntroducePage />;
};
const VisitWay = () => {
  return <VisitWayPage />;
};

export default function BoBIsRouter() {
  return (
    <Routes>
      <Route path='/' element={<BoBIs />} />
      <Route path='/message' element={<Message />} />
      <Route path='/history' element={<History />} />
      <Route path='/bci' element={<BoBCenterIntroduce />} />
      <Route path='/bi' element={<BIIntroduce />} />
      <Route path='/visit' element={<VisitWay />} />
    </Routes>
  );
}
